"use strict";

define('components/updates',['jQuery', 'components/dom_setup', 'components/form', 'components/ajax', 'components/fileuploader'], function($, domSetup, form, ajax, fileUploader) {

    var AUTOSAVE_DELAY_MS = 3000;
    var AUTOSAVE_MESSAGE_DELAY_MS = 500;

    var updatesComponent = {

        init: function () {

            // Nothing to do if there is no update list present.
            var updateListBody = $('#update-list-body');
            if (updateListBody.length === 0 && $('#activity-more-link').length === 0) {
                return;
            }

            updateListBody.click(function(e) {
                var target = $(e.target);
                if (target.is('.note-edit-link')) {
                    e.preventDefault();
                    e.stopPropagation();
                    updatesComponent.switchToEditView(target);
                }
            });
            updatesComponent._initActivityFeed();
            updatesComponent._initAddNoteForm();
        },

        editAttachmentsAddList: {},
        editAttachmentsDeleteList: {},

        _initActivityFeed: function () {
            if (window.location.href.indexOf('portal') > -1) {
                var more_link = $('#activity-more-link');
                more_link.click(function(event) {
                    event.preventDefault();
                    more_link.removeAttr('href');
                    more_link.unbind('click');

                    $.get(more_link.data('source'), function(result) {
                        if (result.status != 'ok') {
                            alert(result.message);
                            return;
                        }

                        var earlier_updates = $(result.body).hide();
                        $('#activity-more').replaceWith(earlier_updates);
                        updatesComponent._initActivityFeed();
                        earlier_updates.slideDown();
                    });
                });
            }
        },

        _initAddNoteForm: function() {

            // Configure form to create a new update
            var addNoteForm = $('#add-note-form');
            addNoteForm.find('#note-types input').change(updatesComponent._onNoteTypeInputChange);

            addNoteForm.on('jsq:objectSelected', function (e, fieldId, name, type, id, subType) {
                updatesComponent.handleParticipantAdd($(this), fieldId, name, type, id, subType);
            });

            addNoteForm.find('#add-note-cancel').click(function (event) {
                event.preventDefault();
                updatesComponent._discardDraft();
            });

            addNoteForm.find('#add-note-submit').click(function (event) {
                event.preventDefault();
                updatesComponent._addNote();
            });

            updatesComponent._figureOutWhenToExpandDraft(addNoteForm);
            updatesComponent._attachParticipantListeners(addNoteForm);
            updatesComponent._attachChangeListeners(addNoteForm);
            updatesComponent._attachTagNoteControls(addNoteForm);
        },

        _onNoteTypeInputChange: function() {
            var addNoteForm = $('#add-note-form');
            var updateType = addNoteForm.find('#note-types input[name="note_type"]:checked');
            if (updateType.data('placeholder')) {
                addNoteForm.find('#add-note-textarea').attr('placeholder', updateType.data('placeholder'));
            }

            var contactParticipantControls = addNoteForm.find('#contact-participant-controls');
            var meetingControls = addNoteForm.find('#meeting-controls');
            var linkToRevealTagNoteControls = addNoteForm.find("#reveal-tag-note-controls");
            var linkToRevealTagMeetingOrCallControls = addNoteForm.find("#reveal-tag-meeting-or-call-controls");
            var bottomMeetingControls = addNoteForm.find('#meeting-controls-bottom');
            var offeringEntityParticipantControls = addNoteForm.find("#offering-entity-participant-controls");
            var noteTypeNoun = addNoteForm.find(".note-type-noun");
            if (updateType.val() == 1) { // Note
                meetingControls.addClass('hidden');
                bottomMeetingControls.addClass('hidden');
                linkToRevealTagMeetingOrCallControls.addClass('hidden');
                linkToRevealTagNoteControls.removeClass('hidden');
                contactParticipantControls.removeClass('hidden');
                offeringEntityParticipantControls.addClass('hidden');
                noteTypeNoun.text("note");
            } else {  // Meeting
                meetingControls.removeClass('hidden');
                bottomMeetingControls.removeClass('hidden');
                linkToRevealTagNoteControls.addClass('hidden');
                contactParticipantControls.removeClass('hidden');
                linkToRevealTagMeetingOrCallControls.removeClass('hidden');
                offeringEntityParticipantControls.addClass('hidden');

                var meetingLocation = addNoteForm.find('#meeting-location');
                if (updateType.val() == 2) {  // in_person
                    meetingLocation.removeClass('hidden');
                    noteTypeNoun.text("meeting");
                } else {  // phone_call
                    meetingLocation.addClass('hidden');
                    noteTypeNoun.text("call");
                }
                form.focusFirstInput($('#note-form-body'));
            }
        },

        _attachTagNoteControls: function(formNode) {
            var linkToRevealTagNoteControls = formNode.find('#reveal-tag-note-controls');
            var contactParticipantControls = formNode.find("#contact-participant-controls");
            var offeringEntityParticipantControls = formNode.find("#offering-entity-participant-controls");

            linkToRevealTagNoteControls.click(function(e) {
               e.preventDefault();
               contactParticipantControls.removeClass('hidden');
               offeringEntityParticipantControls.removeClass('hidden');
               linkToRevealTagNoteControls.addClass('hidden');
            });

            var linkToRevealTagMeetingOrCallControls = formNode.find('#reveal-tag-meeting-or-call-controls');
            linkToRevealTagMeetingOrCallControls.click(function(e) {
                e.preventDefault();
                offeringEntityParticipantControls.removeClass('hidden');
                linkToRevealTagMeetingOrCallControls.addClass('hidden');
            });
        },

        _figureOutWhenToExpandDraft: function(addNoteForm) {
            var addNoteTextArea = addNoteForm.find("[id*='add-note-textarea']");
            addNoteTextArea.focus(function(event) {
            var linkToRevealTagNoteControls = addNoteForm.find("#reveal-tag-note-controls");
                if ($('#add-note-controls').hasClass('hidden')) {
                    linkToRevealTagNoteControls.removeClass('hidden');
                    updatesComponent._expandDraft();
                }
            });
            if (addNoteForm.data('draft-id')) {
                updatesComponent._expandDraft();
            }
        },

        _hideListItem: function(node) {
            var list = node.closest('ul');
            node.closest('li').fadeOut(300, function() {
                node.closest('li').remove();
                if(list.children().length === 0) {
                    $('.potential-participant-list').remove();
                }
            })
        },

        _addParticipantForLink: function(node, formNode) {
            var fieldId = node.data('field-to-populate');
            var objectType = node.data('object-type');
            var objectId = node.data('object-id');
            var objectName = node.data('object-name');

            updatesComponent.handleParticipantAdd(formNode, fieldId, objectName, objectType, objectId);
            updatesComponent._hideListItem($(node));
        },

        _attachParticipantListeners: function(formNode) {


            var noAddParticipantLink = formNode.find('.remove-parent-do-not-want');
            noAddParticipantLink.click(function (e) {
                e.preventDefault();
                updatesComponent._hideListItem($(this));
            });

            var addPotentialParticipantLink = formNode.find('.add-participant-from-staff');
            addPotentialParticipantLink.click(function(e) {
                e.preventDefault();
                updatesComponent._addParticipantForLink($(this), formNode);
            });

            var addAllParticipantsLink = formNode.find('.add-all-staff');
            addAllParticipantsLink.click(function(e) {
                e.preventDefault();
                $(this).closest('.potential-participant-list').find('.add-participant-from-staff').each(function() {
                    updatesComponent._addParticipantForLink($(this), formNode);
                })
            });

            var participantInput = formNode.find('.participant-list input');
            formNode.find('.participant-list').click(function(event) {
                var target = $(event.target);
                if (target.is('.participant-remove')) {
                    target.closest('.note-participant').fadeOut(400, function() {
                        $(this).remove();
                        formNode.trigger('jsq:changedParticipantList');
                    });
                    event.preventDefault();
                }
                // Set focus on the input field in this participant list
                $(this).find('input').focus();
            });

            participantInput.keydown(function (e) {     // Backspace should delete the last participant
                if (e.keyCode == 8 && e.currentTarget.value == 0) {
                    $(this).closest('.participant-list').find('.note-participant:last').remove();
                    formNode.trigger('jsq:changedParticipantList');
                }
            });
            participantInput.blur(function (e) {        // Clear out detritus type-ahead input field on blur
                $(this).typeahead('val', '');
            });
        },

        _expandDraft: function() {
            var addNoteForm = $('#add-note-form');
            addNoteForm.find('#add-note-controls').removeClass('hidden');
            addNoteForm.find('#note-types').removeClass('hidden');
            addNoteForm.find('#note-controls-bottom').removeClass('hidden');
            addNoteForm.closest('#add-note').addClass('module-body-edit').addClass('bg-info');

            updatesComponent._hideFauxTextareaAndShowEditor(addNoteForm);
        },

        handleParticipantAdd: function(formNode, fieldId, name, type, id, subType) {
            var participantList = formNode.find('#'+fieldId).closest('.participant-list');
            if (participantList.find('.note-participant:last').length == 1) {
                participantList.find('.note-participant:last')
                               .after(updatesComponent.create_participant_fragment(type, id, name));
                formNode.trigger('jsq:changedParticipantList');
            } else {
                $(participantList.children()[0]).before(updatesComponent.create_participant_fragment(type, id, name));
                formNode.trigger('jsq:changedParticipantList');
            }

            // Clear out the typeahead input
            $('#'+fieldId).typeahead('val', '');

            // When adding a person contact (type=3), fetch their company and to the organizations list
            if (type == 3 && participantList.is('.person-participants')) {
                $.ajax({
                    url: '/contact/'+id+'/get',
                    type: 'GET',
                    dataType: 'json',
                    success: function(result) {
                        // The person needs to have a company ID
                        if (!result.company_id) {
                            return;
                        }

                        // Add the company only if its not already on the list
                        var orgParticipantList = formNode.find('.org-participants')
                        var companyExists = false;
                        orgParticipantList.find('.note-participant').each(function(index, participant) {
                            if ($(participant).find('input[name=object_type]').val() == 3 &&
                                $(participant).find('input[name=object_id]').val() == result.company_id) {
                                companyExists = true;
                            }
                        });
                        if (companyExists) {
                            return
                        }

                        updatesComponent.handleParticipantAdd(formNode, orgParticipantList.find('input.object_ref_edit').attr('id'),
                                                  result.company_name, 3, result.company_id, 2);
                    }
                });
            }
        },

        create_participant_fragment: function(objectType, objectId, objectName) {
            return '<span class="note-participant">'
                + '<input type="hidden" name="__start__" value="participant:mapping">'
                + '<input type="hidden" name="__start__" value="participant_object:mapping">'
                + '<input name="object_name" type="hidden" value="' + objectName + '">'
                + '<input name="object_type" type="hidden" value="' + objectType + '">'
                + '<input name="object_id" type="hidden" value="' + objectId + '">'
                + '<input type="hidden" name="__end__" value="participant_object:mapping">'
                + '<input type="hidden" name="__end__" value="participant:mapping">'
                + '<span class="label label-participant">' + objectName
                + '<a class="participant-remove">×</a>'
                + '</span>'
                + '</span>';
        },

        // On any input change in $('#add-note-form'), we perform an autosave, but we use a timer so that
        // we do not make unnecessary requests. We also compute a hash of the form values and skip saving
        // if there haven't been any changes.
        _autosaveDraftTimer: null,
        _autosaveDraftLastHash: null,
        _attachChangeListeners: function() {
            var addNoteForm = $('#add-note-form');
            addNoteForm.on('input.Autosave', updatesComponent._onChange)
                       .on('change.Autosave', updatesComponent._onChange)
                       .on('jsq:changedParticipantList.Autosave', updatesComponent._onChange)
                       .on('jsq:fileSelect', updatesComponent._onChange);
        },

        _onChange: function(event) {
            // Ignore if the user is just switching note-types on a blank form.
            var target = $(event.target);
            var addNoteForm = $('#add-note-form');
            var attachment = null;
            if (target.attr('name') === 'note_type' && !addNoteForm.data('draft-id')) {
                return;
            }

            // Ignore changes to the typeahead input field, instead we will autosave on the
            // 'jsq:changedParticipantList' event.
            if (target.hasClass('object_ref_edit')) {
                return;
            }

            // If the user has selected a file/files, let's display the uploading progress bar,
            // hide the upload form, until the autosave ajax request completes or errors.
            if (event.type === 'jsq:fileSelect' || (event.target && event.target.type === 'file')) {
                addNoteForm.find('.error-message').html('');
                var progressBar = addNoteForm.find('#upload-status')
                progressBar.removeClass('hidden');
                var fileUploadField = addNoteForm.find('.file_upload_field');
                fileUploadField.addClass('hidden');
                if (arguments[1]) {
                    attachment = arguments[1][0];
                }
            }

            clearTimeout(updatesComponent._autosaveDraftTimer);
            updatesComponent._autosaveDraftTimer = setTimeout(function() {
                updatesComponent._autosaveDraft(attachment);
            }, AUTOSAVE_DELAY_MS);
        },

        _detachChangeListeners: function() {
            clearTimeout(updatesComponent._autosaveDraftTimer);
            updatesComponent._autosaveDraftTimer = null;
            updatesComponent._autosaveDraftLastHash = null;

            var addNoteForm = $('#add-note-form');
            addNoteForm.off('input.Autosave')
                       .off('change.Autosave')
                       .off('jsq:changedParticipantList.Autosave')
                       .off('jsq:fileSelect');
        },

        _autosaveDraft: function(attachment) {
            var addNoteForm = $('#add-note-form');
            var hash = addNoteForm.serialize();
            var uploadStatus = addNoteForm.find('#upload-status');
            var fileSelection = addNoteForm.find('.file_selection');
            var fileUploadField = addNoteForm.find('.file_upload_field');
            var fileSelect = addNoteForm.find('.file_select');
            var attachmentErrorField = addNoteForm.find('.attachment-error');
            var formData = form.serialize(addNoteForm);

            // Reset required on the drag and drop data attribute so we don't
            // continue to upload the same file over and over again when the form changes.
            fileSelect.data('dragdrop_files', []);

            // The file emitted with the event on drag and drop.
            if (attachment) {
                if (attachment.type == '') {
                  this._handleErrorStateAndCleanup(addNoteForm);
                  return;
                }
                formData.append('upload_create_note_attachment_field', attachment)
            }


            if (updatesComponent._autosaveDraftLastHash === hash) {
                if (!attachment) {
                      $(fileSelection).val('');
                      fileUploadField.removeClass('hidden');
                      uploadStatus.addClass('hidden');
                      return
                }
            }
            updatesComponent._autosaveDraftLastHash = hash;

            form.forceSaveWarning(addNoteForm);

            var submitButton = addNoteForm.find('#add-note-submit');
            submitButton.prop('disabled', true);
            var cancelButton = addNoteForm.find('#add-note-cancel');
            cancelButton.prop('disabled', true);

            var addNoteSubmitStatus = addNoteForm.find('#add-note-submit-status');
            addNoteSubmitStatus.html('<em>Saving draft...</em>');
            var url = addNoteForm.data('save-draft-url');
            attachmentErrorField.html('');


            ajax(url, {
                formData: formData,
                onSuccess: function(result) {
                    // Removes error class and error messages if present
                    var errorNodes = $('#add-note-form').find('.has-error');

                    errorNodes.find('.field-error').remove();
                    errorNodes.removeClass('has-error');

                    if (result.draft_id) {
                        // Technically only `data()` needs to be called. Call `attr()` too so that while debugging what
                        // you see on the dom node in Chrome's element inspector reflects the current value of `data()`.
                        addNoteForm.attr('data-draft-id', result.draft_id).data('draft-id', result.draft_id);
                    }
                    form.resetSaveWarning(addNoteForm);

                    // If the result includes a list of note_attachments, render them here.

                    if (result["note_attachments"] && result["note_attachments"].length > 0) {
                        updatesComponent._renderNoteAttachments(addNoteForm, result)
                    }

                    setTimeout(function() {
                        addNoteSubmitStatus.html('<em>Your draft has been saved.</em>');
                        submitButton.prop('disabled', false);
                        cancelButton.prop('disabled', false);
                        uploadStatus.addClass('hidden');
                        fileUploadField.removeClass('hidden');
                        addNoteForm.find('.file_select')[0].value = '';
                        addNoteForm.find('.file_selection')[0].value = '';
                    }, AUTOSAVE_MESSAGE_DELAY_MS);
                },
                onError: function(result) {
                    attachmentErrorField.removeClass('hidden')
                    attachmentErrorField.html("An error occurred while uploading this file. Please try again.")

                    setTimeout(function() {
                        submitButton.prop('disabled', false);
                        cancelButton.prop('disabled', false);
                        uploadStatus.addClass('hidden');
                        fileUploadField.removeClass('hidden');
                        addNoteForm.find('.file_select')[0].value = '';
                        addNoteForm.find('.file_selection')[0].value = '';
                    }, AUTOSAVE_MESSAGE_DELAY_MS);
                },
                onFailure: function(result) {
                    // Add 'has-error' to any inputs with validation errors.
                    var formNode = $('#add-note-form');
                    var errorNodes = formNode.find('.has-error');
                    errorNodes.find('.field-error').remove();
                    errorNodes.removeClass('has-error');
                    for (var k in result.error_messages) {
                        if (Object.prototype.hasOwnProperty.call(result.error_messages, k)) {
                            var input = formNode.find('.form-control[name="' + k + '"]');
                            input.closest('.form-group').addClass('has-error');
                            input.after('<span class="control-label field-error">' + result.error_messages[k] + '</span>')
                        }
                    }
                    if (result.type === 'note_attachment') {
                        var attachmentErrorField = formNode.find('.attachment-error');
                        attachmentErrorField.removeClass('hidden');
                        attachmentErrorField.html("An error occurred while uploading this file. Please try again.");
                    }

                    setTimeout(function() {
                        addNoteSubmitStatus.html('<em>There are unsaved changes</em>');
                        submitButton.prop('disabled', false);
                        cancelButton.prop('disabled', false);
                        uploadStatus.addClass('hidden');
                        fileUploadField.removeClass('hidden');
                        addNoteForm.find('.file_select')[0].value = '';
                        addNoteForm.find('.file_selection')[0].value = '';
                    }, AUTOSAVE_MESSAGE_DELAY_MS);
                },
            });
        },

        _discardDraft: function() {
            var url = $('#add-note-form').data('discard-draft-url');
            ajax(url, {
                onSuccess: function(result) {
                    updatesComponent._detachChangeListeners();
                    updatesComponent._clearAddNoteForm(result.body);
                },
                onFailure: function() {
                    updatesComponent._attachChangeListeners();
                },
                onError: function() {
                    updatesComponent._attachChangeListeners();
                }
            });
        },

        _clearAddNoteForm: function (newAddNoteHtml) {
            $('#add-note').replaceWith(newAddNoteHtml);
            domSetup.init($('#add-note-form'));
            updatesComponent._initAddNoteForm();
        },

        _addNote: function() {
            updatesComponent._detachChangeListeners();

            var addNoteForm = $('#add-note-form');
            var formData = form.serialize(addNoteForm);
            form.forceSaveWarning(addNoteForm);

            ajax(addNoteForm.data('add-url'), {
                formData: formData,
                onSuccess: function(result) {
                    form.resetSaveWarning(addNoteForm);

                    var new_update = $(result.list_item).hide();
                    $('#update-list-body').prepend(new_update);
                    new_update.slideDown();
                    domSetup.init(new_update);

                    updatesComponent._clearAddNoteForm(result.body);

                    updatesComponent._dismissAlert();
                },
                onFailure: function(result) {
                    updatesComponent._updateDraftFormWithErrors(result.body);
                }
            });
        },

        _renderNoteAttachments: function(addNoteForm, result) {
            var noteAttachmentsList = $(addNoteForm).find('.note-attachments-list');
            var attachmentsString = "";
            for (var i = 0; i < result["note_attachments"].length; i++) {
                var downloadHref = "/note/" + result["note_attachments"][i]["note_id"] + "/note_attachment/" + result["note_attachments"][i]["note_attachment_id"] + "/download";
                var deleteHref = "/note/" + result["note_attachments"][i]["note_id"] + "/note_attachment/" + result["note_attachments"][i]["note_attachment_id"] + "/delete";
                attachmentsString += (
                   "<div id='note-attachment-" + result["note_attachments"][i]["note_attachment_id"] + "'>" +
                   "<span class='glyphicon glyphicon-paperclip'></span>" +
                   "<a class='note-attachment' href=" + downloadHref + " data-cy='uploaded-document-name'>"
                   + result["note_attachments"][i]["document_version_name"] +
                   "</a><a class='delete-note-attachment' data-toggle='modal' data-target='#attachment-modal' href=" + deleteHref + ">x</a><br>" +
                   "</div>"
                )
            }
            $(noteAttachmentsList).html(attachmentsString);
        },

        _updateDraftFormWithErrors: function (newAddNoteHtml) {
            $('#add-note').replaceWith(newAddNoteHtml);
            var addNoteForm = $('#add-note-form');
            domSetup.init(addNoteForm);
            updatesComponent._initAddNoteForm();

            // After replacing the DOM, the hidden states of the textarea and editor are reset, and so we need to
            // explicitly hide the textarea, and show the editor.
            updatesComponent._hideFauxTextareaAndShowEditor(addNoteForm);

            // Figure out the selection.
            var updateType = addNoteForm.find('#note-types input[name="note_type"]:checked');
            updatesComponent._focusInput(addNoteForm, updateType.val());
        },

        switchToEditView: function(editLink) {
            var moduleId = editLink.data('module-id');
            var editUrl = editLink.data('edit-url');
            var self = this;

            $.ajax({
                url: editUrl,
                type: 'GET',
                processData: false,
                success: function(result) {
                    var module = $('#' + moduleId);
                    updatesComponent.initEditModule(module, result);
                    module.on('click', 'button', function(e) {
                        e.preventDefault();
                        var button = $(e.target);
                        var buttonName = button.attr('name');

                        if (buttonName === 'cancel') {
                            updatesComponent.switchToReadView(editLink);
                            self.editAttachmentsAddList = {};
                            self.editAttachmentsDeleteList = {};
                            self._triggerViewLoadedEvent(moduleId)
                            return false;
                        }
                        if (buttonName === 'save') {
                            var editForm = module.find('form');
                            var formData = form.serialize(editForm);
                            updatesComponent.submitEditForm(formData, editLink);
                        }
                    });
                },
            });
        },

        initEditModule: function(module, content) {
            var self = this;
            module.html(content);
            module.addClass('bg-info').addClass('module-body-edit');
            var editForm = module.find('form');
            domSetup.init(editForm);

            // After replacing the DOM, the hidden states of the textarea and editor are reset, and so we need to
            // explicitly hide the textarea, and show the editor.
            updatesComponent._hideFauxTextareaAndShowEditor(editForm);

            // Handle all participant-related events.
            updatesComponent._attachParticipantListeners(editForm);
            editForm.on('jsq:objectSelected', function (e, fieldId, name, type, id, subType) {
                updatesComponent.handleParticipantAdd(editForm, fieldId, name, type, id, subType);
            });

            // Add delete handlers to any attachments that already exist on the page.
            self._addDeleteHandlersToEditAttachmentList(editForm, true);
            var progressBar = editForm.find('#upload-status');
            var fileUploadField = editForm.find('.file_upload_field');
            editForm.on('jsq:fileSelect', function(e) {
                var noteId = editForm.find('input[name="attachment_upload_note_id"]')[0].value;
                var attachmentErrorField = editForm.find('.attachment-error');
                attachmentErrorField.html('');
                if (arguments[1]) {
                    // Create and submit a form exclusively for creating document versions. We'll convert them to
                    // note attachments if the user submits the form.
                    var attachment = arguments[1][0];

                    // Required for Safari when a user drags a folder into the drag and drop section.
                    // We need to detect that it is not a file type and surface an error.
                    if (attachment.type == '') {
                        self._handleErrorStateAndCleanup(editForm);
                        return;
                    }

                    var formData = new FormData();
                    formData.append('upload', attachment);
                    formData.append('note_id', noteId);
                    formData.append('csrf_token', $('meta[name=csrf_token]').attr('content'));

                    editForm.find('.error-message').html('');
                    progressBar.removeClass('hidden');
                    fileUploadField.addClass('hidden');

                    $.ajax({
                        url: '/note/' + noteId + '/note_edit_attachment/upload',
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        dataType: 'json',
                        success: function(result) {
                            var createAttachmentString = function(attachment) {
                                var downloadHref = URL.createObjectURL(attachment)
                                return (
                                    "<div class='edit-note-attachment-container' data-document-version-id='" + result['document_version']['document_version_id']+ "'>" +
                                    "<span class='glyphicon glyphicon-paperclip'></span>" +
                                    "<a download class='note-attachment' href=" + downloadHref + ">&nbsp;"
                                    + attachment.name +
                                    "</a><a class='delete-edit-note-attachment delete-note-attachment'>&nbsp;&nbsp;x</a><br>" +
                                    "</div>"
                                );
                            }
                            if (self.editAttachmentsAddList[noteId]) {
                                self.editAttachmentsAddList[noteId].push(result['document_version']['document_version_id']);
                            } else {
                                self.editAttachmentsAddList[noteId] = [result['document_version']['document_version_id']];
                            }
                            $(editForm).find('.edit-note-attachments-list').append(createAttachmentString(attachment, self.editAttachmentsAddList[noteId].length - 1));

                            // Add delete handlers to any attachments that are subsequently added to the page.
                            self._addDeleteHandlersToEditAttachmentList(editForm, false);
                            self._clearFileInputAndValue(editForm);
                            editForm.find('.error-message').html('');
                            progressBar.addClass('hidden');
                            fileUploadField.removeClass('hidden');
                        },
                        failure: function(result) {
                            self._clearFileInputAndValue(editForm);
                            editForm.find('.error-message').html('');
                            progressBar.addClass('hidden');
                            fileUploadField.removeClass('hidden');
                        },
                        error: function(error) {
                            self._clearFileInputAndValue(editForm);
                            self._handleErrorStateAndCleanup(editForm);
                        }
                    });
                }
            });

            // Figure out where to focus.
            var noteType = editForm.find("[name='note_type']");
            updatesComponent._focusInput(editForm, noteType.val());
        },

        _handleErrorStateAndCleanup: function(form) {
            var attachmentErrorField = form.find('.attachment-error');
            var progressBar = form.find('#upload-status');
            var fileUploadField = form.find('.file_upload_field');
            this._clearFileInputAndValue(form);
            attachmentErrorField.removeClass('hidden');
            attachmentErrorField.html("An error occurred while uploading this file. Please try again.");
            form.find('.error-message').html('');
            progressBar.addClass('hidden');
            fileUploadField.removeClass('hidden');
        },

        _addDeleteHandlersToEditAttachmentList: function(editForm, isExistingAttachmentList) {
            var self = this;
            $('.delete-edit-note-attachment').each(function(idx, el) {
                  $(el).on('click', function(e) {
                      e.preventDefault();
                      var noteId = editForm.find('input[name="attachment_upload_note_id"]')[0].value;
                      var container = $(this).closest('.edit-note-attachment-container')[0];
                      $(this).closest('.edit-note-attachment-container').remove();
                      if (isExistingAttachmentList) {
                          if (self.editAttachmentsDeleteList[noteId]) {
                              self.editAttachmentsDeleteList[noteId].push(container.dataset['noteAttachmentId']);
                          } else {
                              self.editAttachmentsDeleteList[noteId] = [container.dataset['noteAttachmentId']];
                          }
                      } else {
                          if (self.editAttachmentsAddList[noteId]) {
                              var documentVersion = Number(container.dataset.documentVersionId);
                              var documentVersionIndex = self.editAttachmentsAddList[noteId].indexOf(documentVersion);
                              if (documentVersionIndex > -1) {
                                  self.editAttachmentsAddList[noteId].splice(documentVersionIndex, 1);
                              }
                          }
                      }
                  });
            });
        },

        _clearFileInputAndValue: function(fileForm) {
            fileForm.find('.file_selection')[0].value = null;
            fileForm.find('.file_select')[0].value = null;
        },


        _focusInput: function(formNode, noteTypeValue) {
            var errorField = formNode.find('.has-error');
            if (errorField.length > 0) {
                form.focusFirstInput(errorField);
            } else {
                form.focusFirstInput(formNode);
            }
        },

        switchToReadView: function(editLink) {
            var viewUrl = editLink.data('view-url');
            var moduleId = editLink.data('module-id');
            var module = $('#' + moduleId);

            $.get(viewUrl, null, function(result) {
                var editForm = module.find('form');

                module.off('click', 'button');
                module.html(result);
                module.removeClass('bg-info').removeClass('module-body-edit');
                domSetup.init(module);
            });
        },

        submitEditForm: function(formData, editLink) {

            var moduleId = editLink.data('module-id');
            var module = $('#' + moduleId);
            var noteId = module.find('input[name="id"]')[0].value
            var editForm = module.find('form');

            var self = this;

            var onSuccessFunc = function(result) {
                self.editAttachmentsAddList = {};
                module.html(result.body);
                domSetup.init(module);
                module.off('click', 'button');
                module.removeClass('bg-info').removeClass('module-body-edit');

                updatesComponent._dismissAlert();
                updatesComponent._triggerViewLoadedEvent(moduleId)

            };

            var onFailureFunc = function(result) {
                updatesComponent.initEditModule(module, result.body);
                self.editAttachmentsAddList = {};
                // After replacing the DOM, the hidden states of the textarea and editor are reset, and so we
                // need to explicitly hide the textarea, and show the editor.
                updatesComponent._hideFauxTextareaAndShowEditor(editForm);

                // If there were any attachment drafts, add them back in memory for
                // resubmission.
                var noteId = module.find('input[name="id"]')[0].value
                module.find('.edit-note-attachment-container')
                  .each(function(idx, item) {
                      self.editAttachmentsAddList[noteId] = [item.dataset['documentVersionId']];
                  })
            };

            var editNoteAjaxCall = function(url, formData) {
                ajax(url, {
                    formData: formData,
                    onSuccess: function(result) {
                        $(document).off('shown.bs.modal', '#edit-note-share-update-modal', onNoteShareUpdateModalShown);
                        onSuccessFunc(result);
                    },
                    onFailure: function(result) {
                        $(document).off('shown.bs.modal', '#edit-note-share-update-modal', onNoteShareUpdateModalShown);
                        onFailureFunc(result);
                    }
                });
            };

            var onNoteShareUpdateModalShown = function() {
                var modalNode = $(this);
                var submitButton = modalNode.find('button[data-save-url]');
                submitButton.on('click', function() {
                    var shareUpdateValue = modalNode.find('form').find('input[name="share_update"]:checked');
                    formData.append('share_update', shareUpdateValue.val());    // IMPORTANT: User's confirmation value
                    editNoteAjaxCall(submitButton.data('save-url'), formData);
                    modalNode.modal('hide');
                });
            };

            /* The edit-note AJAX submission, editNoteAjaxCall(), below may result in a dialog box being brought up,
             * which prompts the user for a confirmation. In which case, its onSuccess() and onFailure() would never get
             * called because the dialog would take over. But, we still want to "resume" somehow AFTER the confirmation
             * dialog has been dismissed, i.e. after the dialog has been dismissed, we still want to submit the changes
             * that result from editing the note. And so,
             *
             *  1. We "resume" by handling the dialog's submission ourselves--we listen to the shown.bs.modal event so
             *     that we can bind to the submit button. Caution needs to be applied here: When the confirmation
             *     dialog is NOT brought up (i.e. either onSuccess() or onFailure() is called instead), we need to
             *     remove our shown.bs.modal event handler, otherwise when the confirmation dialog does need to be
             *     displayed, the handler would be called multiple times.
             *
             *  2. We append share_update to the formData so that the controller knows when the user has confirmed.
             *     Thus, the controller needs to check for the existence of share_update in the POST payload.
             */
            $(document).one('shown.bs.modal', '#edit-note-share-update-modal', onNoteShareUpdateModalShown);

            if (this.editAttachmentsAddList[noteId]) {
                formData.append('document_version_ids', this.editAttachmentsAddList[noteId])
            }
            if (this.editAttachmentsDeleteList[noteId]) {
                formData.append('note_attachments_to_delete', this.editAttachmentsDeleteList[noteId])
            }

            editNoteAjaxCall(editLink.data('edit-url'), formData);
        },

        _hideFauxTextareaAndShowEditor: function(formNode) {
            var noteTextarea = formNode.find("[id*='add-note-textarea']");
            noteTextarea.addClass('hidden');
            var textareaError = noteTextarea.closest('.has-error');
            if (textareaError) {
                textareaError.addClass('hidden');
            }
            var editorDiv = formNode.find("[id*='add-note-div']");
            editorDiv.removeClass('hidden');

            // render pillars since we need to show tinymce
            if(typeof window.__jsqRenderPillars__ === 'function') {
                window.__jsqRenderPillars__();
            }
        },

        _dismissAlert: function() {
            $("#crm-notification-success").fadeTo(5000, 1.0).slideUp(500, function(){
                $("#crm-notification-success").alert('close');
            });
        },

        _triggerViewLoadedEvent: function(moduleId) {
            window.dispatchEvent(new CustomEvent('jsq:updateViewLoaded', { detail: { moduleId: moduleId } }));
        }

    };

    return updatesComponent;
});

